export const datepicker = {
  now: '此刻',
  today: '今天',
  cancel: '取消',
  clear: '清空',
  confirm: '确定',
  selectDate: '选择日期',
  selectTime: '选择时间',
  startDate: '开始日期',
  startTime: '开始时间',
  endDate: '结束日期',
  endTime: '结束时间',
  prevYear: '前一年',
  nextYear: '后一年',
  prevMonth: '上个月',
  nextMonth: '下个月',
  year: '年',
  month1: '1 月',
  month2: '2 月',
  month3: '3 月',
  month4: '4 月',
  month5: '5 月',
  month6: '6 月',
  month7: '7 月',
  month8: '8 月',
  month9: '9 月',
  month10: '10 月',
  month11: '11 月',
  month12: '12 月',
  // week: '周次',
  weeks: {
    sun: '日',
    mon: '一',
    tue: '二',
    wed: '三',
    thu: '四',
    fri: '五',
    sat: '六'
  },
  months: {
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '五月',
    jun: '六月',
    jul: '七月',
    aug: '八月',
    sep: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月'
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-date-picker2/src/utils/datepicker.js